import doctorAPI from '../../api/doctor'
import Vue from 'vue'

// State
const state = {
  notifications: []
}

// Getters
const getters = {
  getNotifications () {
    return state.notifications
  },
  getNotViewedCount () {
    let notifications = state.notifications.filter(function (ele) {
      return (ele.is_viewed === false)
    })
    return notifications.length > 0 ? notifications.length : 0
  },
  getLatestNotification () {
    return state.notifications[0]
  }
}

// Actions
const actions = {
  init ({ commit, dispatch }) {
    doctorAPI.getNotificatons().then(response => {
      if (response.status === 200) {
        commit('setUpNotifications', response.body.notifications)
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },
  addNotification ({commit}, {notification}) {
    commit('addNotification', notification)
  },
  updateViewed ({commit, dispatch}, id) {
    doctorAPI.updateViewed(id).then(response => {
      if (response.status === 200) {
        commit('setUpNotifications', response.body.notifications)
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },
  UpdateRead ({commit, dispatch}, id) {
    doctorAPI.updateRead(id).then(response => {
      if (response.status === 200) {
        commit('updateRead', id)
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },
  sendEnquiryToPatient ({commit, dispatch}, {id, message}) {
    doctorAPI.sendEnquiry({id: id, message: message}).then(response => {
      if (response.status === 200) {
        Vue.$toast.open({
          message: 'Enquiry sent successfully',
          type: 'success',
          position: 'top',
          queue: false
        })
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  }
}

// Mutations
const mutations = {
  setUpNotifications (state, notifications) {
    state.notifications = notifications
  },
  addNotification (state, notification) {
    state.notifications.unshift(notification)
  },
  updateViewedNotifications (state) {
  },
  updateRead (state, id) {
    let n = state.notifications.find(function (c) {
      if (c.id === id) return c
    })
    if (n) {
      let i = state.notifications.indexOf(n)
      state.notifications[i].is_read = true
    }
  },
  reset (state) {
    state = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/notification.js